import React from 'react'
import { Row, Col } from 'react-bootstrap'
import UserFullName from '../../user/full-name'
import DateConversational from '../../date/conversational'
import { PeopleFill, Calendar3 } from 'react-bootstrap-icons'

const OutboxMessage = ({
    message
}) => {
    return (
        <Col xl={12} style={{ paddingTop: '20px'}}>
            <div style={{
                boxShadow: '0px 0px 20px 10px rgb(238, 247, 255)',
                padding: '20px'
            }}>
                <Row style={{ paddingBottom: '10px'}}>
                    <Col>
                        <Row><Col style={{ fontSize: '20px', textOverflow: 'ellipsis' }}><strong>{message.subject}</strong></Col></Row>
                        <Row>
                            <Col>
                                <div style={{ display: 'flex', alignItems: 'center'}}>
                                    <PeopleFill size={20} />
                                    <UserFullName user={message.recipient} style={{paddingLeft: '10px', fontSize: '12px'}} className='ellipsis-truncate' />
                                </div>
                            </Col>
                            <Col>
                                <div style={{ display: 'flex', alignItems: 'center'}}>
                                    <Calendar3 size={20} />
                                    <DateConversational date={message.createdDate} style={{paddingLeft: '10px', fontSize: '12px'}} dayName />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col style={{
                        color: 'black',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                    }}>
                        {message.content}
                    </Col>
                </Row>
            </div>
        </Col>
    )
}

export default OutboxMessage